import { AxiosResponse, AxiosError } from "axios";
import apiClient from './ApiConfig';

export interface LoginInfo {
  // check if this is set to determine whether the user is logged in
  id: number;

  first_name: string;
  last_name: string;
  year: number;
  chapter: string;
  type: string; // user type: 'normal' or 'admin'
  InitiationNumber: number;
  MITAlumniID: string;
  Enabled: boolean;
  PledgeClassID: number;
  BigBrotherID: number;
  FamilyID: number;
}

export function EmptyLoginInfo(): LoginInfo {
  let result = {} as LoginInfo;

  return result;
}


export function APIGetSSOKey(
  callback: (statusCode: number, key: string) => void
) {
  apiClient({
    method: "post",
    url: "/login/get_sso_key",
  })
    .then(function (response: AxiosResponse) {
      callback(response.status, response.data.key);
    })
    .catch(function (error: AxiosError) {
      callback(error.response?.status || 0, "");
    });
}

export function APIRecordLogin(
  callback: (statusCode: number) => void
) {
  apiClient({
    method: "post",
    url: "/login/record",
  })
    .then(function (response: AxiosResponse) {
      callback(response.status);
    })
    .catch(function (error: AxiosError) {
      callback(error.response?.status || 0);
    });
}
